import ISessionSetMemberTransferAgreedRequestParams from '@/models/Session/interfaces/ISessionSetMemberTransferAgreedRequestParams';
import { ISessionSetSocialLoginConfirmedRequestParams } from '@/models/Session/interfaces/ISessionSetSocialLoginConfirmedRequestParams';
import SessionSetGlobalPlaceFiltersJSC from '@/schema/SessionSetGlobalPlaceFiltersJSC';
import SessionSetMemberTransferAgreedJSC from '@/schema/SessionSetMemberTransferAgreedJSC';
import SessionSetPlaceFiltersJSC from '@/schema/SessionSetPlaceFiltersJSC';
import SessionSetSocialLoginConfirmedJSC from '@/schema/SessionSetSocialLoginConfirmedJSC';
import { Either } from 'tsmonad';

import { TReqConfigValidated } from '../../services/JSCService';
import { SunnyRequestBuilder } from '../Common/SunnyRequestBuilder';
import { ISessionSetGlobalPlaceFiltersRequestParams } from './interfaces/ISessionSetGlobalPlaceFiltersRequestParams';
import { ISessionSetPlaceFiltersRequestParams } from './interfaces/ISessionSetPlaceFiltersRequestParams';

export class SessionRequestBuilder extends SunnyRequestBuilder {
  createPostSetGlobalPlaceFiltersQuery(reqParams: ISessionSetGlobalPlaceFiltersRequestParams): TReqConfigValidated {
    return this.validate(SessionSetGlobalPlaceFiltersJSC, reqParams).map((params) =>
      this.makeConfig('POST', '/session/global_place_filters', params),
    );
  }

  createGetGlobalPlaceFiltersQuery(): TReqConfigValidated {
    return Either.right(this.makeConfig('GET', '/session/global_place_filters'));
  }

  createPostSetPlaceFiltersQuery(reqParams: ISessionSetPlaceFiltersRequestParams): TReqConfigValidated {
    return this.validate(SessionSetPlaceFiltersJSC, reqParams).map((params) =>
      this.makeConfig('POST', '/session/place_filters', params),
    );
  }

  createGetPlaceFiltersQuery(): TReqConfigValidated {
    return Either.right(this.makeConfig('GET', '/session/place_filters'));
  }

  createPostSetSocialLoginConfirmedQuery(reqParams: ISessionSetSocialLoginConfirmedRequestParams): TReqConfigValidated {
    return this.validate(SessionSetSocialLoginConfirmedJSC, reqParams).map((params) =>
      this.makeConfig('POST', '/session/social_login_confirmed', params),
    );
  }

  createPostSetMemberTransferAgreed(reqParams: ISessionSetMemberTransferAgreedRequestParams): TReqConfigValidated {
    return this.validate(SessionSetMemberTransferAgreedJSC, reqParams).map((params) =>
      this.makeConfig('POST', '/session/member_transfer_agreed', params),
    );
  }

  createGetNolConnected(): TReqConfigValidated {
    return Either.right(this.makeConfig('GET', '/session/nol_connected'));
  }

  createGetIsShowNicknameTooltip(): TReqConfigValidated {
    return Either.right(this.makeConfig('GET', '/session/is_show_nickname_tooltip'));
  }

  createGetIsShowMembershipBadge(): TReqConfigValidated {
    return Either.right(this.makeConfig('GET', '/session/is-show-membership-badge'));
  }

  protected getAPIEndpoint(path: string): string {
    return `/api/v1${path}`;
  }
}
